/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Sync progress" |
*
* @param {Sync_Changes_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_progress_label = /** @type {((inputs?: Sync_Changes_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de la synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierungsfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progresso della sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ход синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de sincronización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("同步进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期の進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizar progresso")
	return /** @type {LocalizedString} */ ("Sync progress")
});